import { render, staticRenderFns } from "./devicepart.vue?vue&type=template&id=0b7d1374&scoped=true&"
import script from "./devicepart.vue?vue&type=script&lang=js&"
export * from "./devicepart.vue?vue&type=script&lang=js&"
import style0 from "./devicepart.vue?vue&type=style&index=0&id=0b7d1374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d1374",
  null
  
)

export default component.exports